const STATUS_STYLES: Record<string, string> = {
  active: 'bg-onyx-success/20 text-onyx-success',
  pending: 'bg-onyx-warn/20 text-onyx-warn',
  suspended: 'bg-onyx-danger/20 text-onyx-danger',
  blacklisted: 'bg-onyx-danger/30 text-onyx-danger',
  executed: 'bg-onyx-success/20 text-onyx-success',
  rejected: 'bg-onyx-danger/20 text-onyx-danger',
  won: 'bg-onyx-success/20 text-onyx-success',
  lost: 'bg-onyx-danger/20 text-onyx-danger',
  'under review': 'bg-onyx-warn/20 text-onyx-warn',
};

export function Badge({ status }: { status: string }) {
  const key = status.toLowerCase();
  const cls = STATUS_STYLES[key] ?? 'bg-onyx-border/40 text-onyx-muted';
  return (
    <span className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium capitalize ${cls}`}>
      {status.replace(/_/g, ' ')}
    </span>
  );
}
